import * as React from 'react';
import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/charts/content-security-policy/content-security-policy.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
